import React, { useState, useEffect, useContext } from "react";
import { Parser } from 'html-to-react'
import Typography from "@mui/material/Typography";
import ReactPlayer from 'react-player'

export const VideoIntro = (props) => {
    const videoPath = "/videos/" + props.modelCode + "/intro.mp4";

    return (
        <div className="container-fluid pt-2">
            <div className="row vh-lg-100">
                <div className="valign">
                    <div className="align-middle d-table-cell">
                        <div className="d-table mx-auto">
                            <div className="row">
                                <Typography component="div" className="video-intro" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
                                    <ReactPlayer
                                        url={videoPath}
                                        controls={false}
                                        playing={true}
                                        muted={true}
                                        loop={true}
                                        width="100%"
                                        height="100%"
                                    />
                                </Typography>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VideoIntro;